<template>
  <div>
    <el-header style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header> 

    <el-main v-loading.fullscreen.lock="loading">
      <el-card class="box-card" style="width:50%">
        <div slot="header" class="clearfix">
          <span>{{this.$i18n.t('field.modifyPassword')}}</span>          
        </div>
        <el-form :model="form" ref="form" label-width="200px" :rules="rules">        
            <el-form-item :label="$t('field.oldPassword')" prop="oldPassword">
              <el-input v-model="form.oldPassword" maxlength=100 show-password ></el-input>
            </el-form-item>
            
            <el-form-item :label="$t('field.newPassword')" prop="newPassword">
              <el-input v-model="form.newPassword" maxlength=100 show-password></el-input>
            </el-form-item>
           
             <el-form-item :label="$t('field.dbConfirmPassword')">
              <el-input v-model="form.dbConfirmPassword" maxlength=100 show-password></el-input>
            </el-form-item>
            <div style="text-align:center">
              <el-button type="warning" @click="save"  size="small">{{$t('button.save')}}</el-button>
            </div>
          </el-form>
      </el-card>
      <br><br>
<span style="color:darkred"> *Password Rule: {{ $t('msg.passwordRule')}}</span>
    </el-main>
  </div>
</template>

<script>
import Breadcrumb from '../components/Breadcrumb.vue'
import { apiModifyPass } from "../../utils/api.js";
import authHeader from "../../services/auth-header";
import CommonUtil from "../../utils/commonUtil.js";



export default {
  name: 'accountManagement',
  data() {   
    return {    
      loading:false, 
      passHint:'',
      form:{
        oldPassword: '',
        newPassword:'',
        dbConfirmPassword:'',
      },      
      rules: {
        oldPassword: [
          { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'blur'}
          //{ type: 'email', message: 'Please input correct username address', trigger: ['blur', 'change'] }
        ],
        newPassword: [
          { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'blur' },
          { min: 8, max:15, message: this.$i18n.t('msg.passwordRule'), trigge:  'blur' }
        ]
      },
    };
  },   
  components: {
    Breadcrumb
  },
  mounted() {
    this.passHint = this.$i18n.t('msg.passwordRule').replace(',','<br/>');
  },
   methods: {
    save(){
      this.$refs['form'].validate((isValid) => {
        if (!isValid) {
          return this.$message.error({message: this.$i18n.t('msg.incompleteInfo'), duration: 1000});
        } else {
          var reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,15}$/;
          var chkPassword = reg.test(this.form.newPassword);
        
          if(chkPassword && (this.form.newPassword != this.form.oldPassword)){
            if(this.form.newPassword != this.form.dbConfirmPassword){
              return this.$message.error({message: this.$i18n.t('msg.newPasswordNotCorr'), duration: 1200});
            }else{      
              apiModifyPass({ headers: authHeader(), oldPassword: this.form.oldPassword, newPassword: this.form.newPassword, dbConfirmPassword: this.form.dbConfirmPassword}).then((response) => {   
          
                if(response.data ==true ){
                  this.loading = false;
                  this.$message({ type: "success", message: this.$i18n.t('msg.saveSuccess'), duration: 800});
                  this.form.oldPassword = '';
                  this.form.newPassword= '';
                  this.form.dbConfirmPassword= '';
                }else{
                  this.loading = false;
                  this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 800});
                }
                
              }).catch((err) => {
                console.log(err);
                this.loading = false;
                this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 800});
              });
            }
          }else{
            return this.$message.error({message: this.$i18n.t('msg.passwordRule'), duration: 3000});
          }
        }
      });

        
    }
  }
};
</script>
